// extracted by mini-css-extract-plugin
export var chevron = "style-module--chevron--3b852";
export var dropDown = "style-module--dropDown--b3b50";
export var language = "style-module--language--83391";
export var languageSelector__button = "style-module--language-selector__button--2f046";
export var languageSelector__dropDown = "style-module--language-selector__drop-down--822c3";
export var languages = "style-module--languages--edb76";